var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCarrotWhiteUp = function SvgIconCarrotWhiteUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 9L8.62311 1.16072C8.67258 1.10977 8.73133 1.06935 8.796 1.04177C8.86067 1.01419 8.92999 1 9 1C9.07001 1 9.13933 1.01419 9.204 1.04177C9.26867 1.06935 9.32742 1.10977 9.37689 1.16072L17 9",
    stroke: "white",
    strokeWidth: 1.36667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgIconCarrotWhiteUp;